import { Pipe, PipeTransform } from '@angular/core';
import dayjs, { Dayjs } from 'dayjs';
import { DateTimeFormat } from './date-time.pipe';

@Pipe({ name: 'nimmstaTime' })
export class TimePipe implements PipeTransform {
  transform(
    value?: Dayjs | Date | number | string,
    format: DateTimeFormat = DateTimeFormat.DATE_TIME_LONG,
  ): string {
    let date: Dayjs | undefined;
    if (typeof value === 'number' && value < 10000000000) {
      date = dayjs(value * 1000);
    } else if (typeof value === 'string' && /^\d+$/.test(value)) {
      date = dayjs(Number.parseInt(value, 10));
    } else if (value) {
      date = dayjs(value);
    }
    return date?.locale(dayjs.locale()).format(format) || '';
  }
}
